 


// import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
// import { useEffect } from "react";

// import HomePageTwo from "./pages/HomePageTwo";
// import ErrorPage from "./pages/ErrorPage";
// import RouteScrollToTop from "./helper/RouteScrollToTop";
// import HomePageTen from "./pages/HomePageTen";

// // ----------------Import Drift Pages----------------//
// import LoginPage from "./pages/DriftPages/LoginPage";
// import CreateUserPage from "./pages/DriftPages/CreateUserPage";
// import UserTablePage from "./pages/DriftPages/UserTablePage";
// import UserProfilePage from "./pages/DriftPages/UserProfilePage";

// import { allUserRoutes } from "./routes/allUserRoutes.js";
// import EditDesign from "./components/DriftComponents/Productsmanagment/EditDesign.jsx";
// import CustomerLogin from "./components/DriftComponents/CustomerLogin.jsx";
// import CustomerProfile from "./components/DriftComponents/CustomerProfile.jsx";
// import CustomerOrdersTable from "./components/CustomerLogin/MyOrders.jsx";
// import AddCustomerOrder from "./components/CustomerLogin/AddCustomerOrder.jsx";
// import EditCustomerOrder from "./components/CustomerLogin/EditCustomerOrder.jsx";
// import ViewOrderDetails from "./components/CustomerLogin/ViewOrderDetails.jsx";
// import CustomerDeleverySlip from "./components/CustomerLogin/CustomerDeleverySlip.jsx";
// import VersionUpdates from "./components/VersionUpdates.jsx";

// // Import RackProvider
// import { RackProvider } from "./components/DriftComponents/RackManagement/RackContext";

// function App() {
//   const token = localStorage.getItem("token");
//   const role = localStorage.getItem("role");
//   const user = JSON.parse(localStorage.getItem("user"));

//   useEffect(() => {
//     const checkTokenExpiration = () => {
//       const expiresAt = localStorage.getItem("expires_at");
//       if (expiresAt && new Date() > new Date(expiresAt)) {
//         localStorage.clear();
//         window.location.href = "/login";
//       }
//     };

//     checkTokenExpiration();
//     const interval = setInterval(checkTokenExpiration, 60000);
//     return () => clearInterval(interval);
//   }, []);

//   const generateUserRoutes = (permissions) => {
//     if (!permissions) return [];
    
//     return allUserRoutes
//       .filter((route) => permissions[route.permissionKey] === 1)
//       .map((route, index) => {
//         const RouteElement = route.element;
//         return (
//           <Route
//             key={`${index}-${route.path}`}
//             path={route.path}
//             element={
//               <VersionUpdates>
//                 <RouteElement />
//               </VersionUpdates>
//             }
//           />
//         );
//       });
//   };

//   // Wrapper component that conditionally applies RackProvider
//   const AppContent = () => {
//     const isLoginPage = window.location.pathname === '/login' || 
//                         window.location.pathname === '/customer/login';
    
//     // If it's a login page, render without RackProvider
//     if (isLoginPage) {
//       return (
//         <Routes>
//           <Route path="/" element={<Navigate to="/login" />} />
//           <Route path="/login" element={<LoginPage />} />
//           <Route path="/customer/login" element={<CustomerLogin />} />
//           <Route path="*" element={<LoginPage />} />
//         </Routes>
//       );
//     }

//     // For all other pages, wrap with RackProvider
//     return (
//       <RackProvider>
//         <Routes>
//           {token && role === "customer" ? (
//             <>
//               <Route
//                 path="/customer/dashboard"
//                 element={
//                   <VersionUpdates>
//                     <HomePageTen />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/customerProfile/:userId"
//                 element={
//                   <VersionUpdates>
//                     <CustomerProfile />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/customer/myorder"
//                 element={
//                   <VersionUpdates>
//                     <CustomerOrdersTable />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/customer/myordereidt/:orderid/:productid"
//                 element={
//                   <VersionUpdates>
//                     <EditCustomerOrder />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/customer/myorderview/:orderid/:productid"
//                 element={
//                   <VersionUpdates>
//                     <ViewOrderDetails />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/customer/delevery_slip"
//                 element={
//                   <VersionUpdates>
//                     <CustomerDeleverySlip />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/customer/addorder"
//                 element={
//                   <VersionUpdates>
//                     <AddCustomerOrder />
//                   </VersionUpdates>
//                 }
//               />
//               <Route path="/customer/login" element={<Navigate to="/customer/login" />} />
//               <Route path="/login" element={<Navigate to="/customer/login" />} />
//               <Route path="*" element={<ErrorPage />} />
//             </>
//           ) : token && user?.department === "admin" ? (
//             <>
//               <Route
//                 path="/"
//                 element={
//                   <VersionUpdates>
//                     <HomePageTwo />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/user-table"
//                 element={
//                   <VersionUpdates>
//                     <UserTablePage />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/user-table/user-create"
//                 element={
//                   <VersionUpdates>
//                     <CreateUserPage />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/user-table/user-profile/:userId"
//                 element={
//                   <VersionUpdates>
//                     <UserProfilePage />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/myProfile/:userId"
//                 element={
//                   <VersionUpdates>
//                     <UserProfilePage />
//                   </VersionUpdates>
//                 }
//               />
//               {generateUserRoutes(user)}
//               <Route
//                 path="/products/series/seriesdetails/edit-design/:masterId/:seriesId/:designID"
//                 element={
//                   <VersionUpdates>
//                     <EditDesign />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/products/designe/edit/:designID"
//                 element={
//                   <VersionUpdates>
//                     <EditDesign />
//                   </VersionUpdates>
//                 }
//               />
//               <Route path="/login" element={<Navigate to="/" />} />
//               <Route path="*" element={<ErrorPage />} />
//             </>
//           ) : token && user?.department !== "admin" ? (
//             <>
//               <Route
//                 path="/"
//                 element={
//                   <VersionUpdates>
//                     <HomePageTwo />
//                   </VersionUpdates>
//                 }
//               />
//               {generateUserRoutes(user)}
//               <Route
//                 path="/products/series/seriesdetails/edit-design/:masterId/:seriesId/:designID"
//                 element={
//                   <VersionUpdates>
//                     <EditDesign />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/products/designe/edit/:designID"
//                 element={
//                   <VersionUpdates>
//                     <EditDesign />
//                   </VersionUpdates>
//                 }
//               />
//               <Route
//                 path="/myProfile/:userId"
//                 element={
//                   <VersionUpdates>
//                     <UserProfilePage />
//                   </VersionUpdates>
//                 }
//               />
//               <Route path="/login" element={<Navigate to="/" />} />
//               <Route path="*" element={<ErrorPage />} />
//             </>
//           ) : (
//             <>
//               <Route path="/" element={<Navigate to="/login" />} />
//               <Route path="/login" element={<LoginPage />} />
//               <Route path="/customer/login" element={<CustomerLogin />} />
//               <Route path="*" element={<LoginPage />} />
//             </>
//           )}
//         </Routes>
//       </RackProvider>
//     );
//   };

//   return (
//     <BrowserRouter>
//       <RouteScrollToTop />
//       <AppContent />
//     </BrowserRouter>
//   );
// }

// export default App;



import { useEffect, Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";


import RouteScrollToTop from "./helper/RouteScrollToTop";
 import { allUserRoutes } from "./routes/allUserRoutes.js";
// Import RackProvider
import { RackProvider } from "./components/DriftComponents/RackManagement/RackContext";
import Loader from "./components/DriftComponents/Loader.jsx";

// Lazy load all page components
const HomePageTwo = lazy(() => import("./pages/HomePageTwo"));
const ErrorPage = lazy(() => import("./pages/ErrorPage"));
const HomePageTen = lazy(() => import("./pages/HomePageTen"));

// Lazy load Drift Pages
const LoginPage = lazy(() => import("./pages/DriftPages/LoginPage"));
const CreateUserPage = lazy(() => import("./pages/DriftPages/CreateUserPage"));
const UserTablePage = lazy(() => import("./pages/DriftPages/UserTablePage"));
const UserProfilePage = lazy(() => import("./pages/DriftPages/UserProfilePage"));

// Lazy load components
const EditDesign = lazy(() => import("./components/DriftComponents/Productsmanagment/EditDesign"));
const CustomerLogin = lazy(() => import("./components/DriftComponents/CustomerLogin"));
const CustomerProfile = lazy(() => import("./components/DriftComponents/CustomerProfile"));
const CustomerOrdersTable = lazy(() => import("./components/CustomerLogin/MyOrders"));
const AddCustomerOrder = lazy(() => import("./components/CustomerLogin/AddCustomerOrder"));
const EditCustomerOrder = lazy(() => import("./components/CustomerLogin/EditCustomerOrder"));
const ViewOrderDetails = lazy(() => import("./components/CustomerLogin/ViewOrderDetails"));
const CustomerDeleverySlip = lazy(() => import("./components/CustomerLogin/CustomerDeleverySlip"));
const VersionUpdates = lazy(() => import("./components/VersionUpdates"));

// Loading component for Suspense fallback
 

// Wrapper component for lazy-loaded components with VersionUpdates
const LazyWrapper = ({ component: Component, ...props }) => (
  <Suspense fallback={<Loader />}>
    <VersionUpdates>
      <Component {...props} />
    </VersionUpdates>
  </Suspense>
);

function App() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const checkTokenExpiration = () => {
      const expiresAt = localStorage.getItem("expires_at");
      if (expiresAt && new Date() > new Date(expiresAt)) {
        localStorage.clear();
        window.location.href = "/login";
      }
    };

    checkTokenExpiration();
    const interval = setInterval(checkTokenExpiration, 60000);
    return () => clearInterval(interval);
  }, []);

 const generateUserRoutes = (permissions) => {
  if (!permissions) return [];

  return allUserRoutes
    .filter((route) => permissions[route.permissionKey] === 1)
    .map((route, index) => {
      const RouteElement = route.element;

      let element = (
        <Suspense fallback={<Loader />}>
          <VersionUpdates>
            <RouteElement />
          </VersionUpdates>
        </Suspense>
      );

      if (route.useRackProvider) {
        element = (
          <Suspense fallback={<Loader />}>
            <VersionUpdates>
              <RackProvider>
                <RouteElement />
              </RackProvider>
            </VersionUpdates>
          </Suspense>
        );
      }

      return (
        <Route
          key={`${index}-${route.path}`}
          path={route.path}
          element={element}
        />
      );
    });
};

  // Wrapper component that conditionally applies RackProvider
  const AppContent = () => {
    const isLoginPage = window.location.pathname === '/login' || 
                        window.location.pathname === '/customer/login';
    
    // If it's a login page, render without RackProvider
    if (isLoginPage) {
      return (
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/customer/login" element={<CustomerLogin />} />
            <Route path="*" element={<LoginPage />} />
          </Routes>
        </Suspense>
      );
    }

    // For all other pages, wrap with RackProvider
    return (
      // <RackProvider>
        <Suspense fallback={<Loader />}>
          <Routes>
            {token && role === "customer" ? (
              <>
                <Route
                  path="/customer/dashboard"
                  element={<LazyWrapper component={HomePageTen} />}
                />
                <Route
                  path="/customerProfile/:userId"
                  element={<LazyWrapper component={CustomerProfile} />}
                />
                <Route
                  path="/customer/myorder"
                  element={<LazyWrapper component={CustomerOrdersTable} />}
                />
                <Route
                  path="/customer/myordereidt/:orderid/:productid"
                  element={<LazyWrapper component={EditCustomerOrder} />}
                />
                <Route
                  path="/customer/myorderview/:orderid/:productid"
                  element={<LazyWrapper component={ViewOrderDetails} />}
                />
                <Route
                  path="/customer/delevery_slip"
                  element={<LazyWrapper component={CustomerDeleverySlip} />}
                />
                <Route
                  path="/customer/addorder"
                  element={<LazyWrapper component={AddCustomerOrder} />}
                />
                <Route path="/customer/login" element={<Navigate to="/customer/login" />} />
                <Route path="/login" element={<Navigate to="/customer/login" />} />
                <Route path="*" element={<ErrorPage />} />
              </>
            ) : token && user?.department === "admin" ? (
              <>
                <Route
                  path="/"
                  element={<LazyWrapper component={HomePageTwo} />}
                />
                <Route
                  path="/user-table"
                  element={<LazyWrapper component={UserTablePage} />}
                />
                <Route
                  path="/user-table/user-create"
                  element={<LazyWrapper component={CreateUserPage} />}
                />
                <Route
                  path="/user-table/user-profile/:userId"
                  element={<LazyWrapper component={UserProfilePage} />}
                />
                <Route
                  path="/myProfile/:userId"
                  element={<LazyWrapper component={UserProfilePage} />}
                />
                {generateUserRoutes(user)}
                <Route
                  path="/products/series/seriesdetails/edit-design/:masterId/:seriesId/:designID"
                  element={<LazyWrapper component={EditDesign} />}
                />
                <Route
                  path="/products/designe/edit/:designID"
                  element={<LazyWrapper component={EditDesign} />}
                />
                <Route path="/login" element={<Navigate to="/" />} />
                <Route path="*" element={<ErrorPage />} />
              </>
            ) : token && user?.department !== "admin" ? (
              <>
                <Route
                  path="/"
                  element={<LazyWrapper component={HomePageTwo} />}
                />
                {generateUserRoutes(user)}
                <Route
                  path="/products/series/seriesdetails/edit-design/:masterId/:seriesId/:designID"
                  element={<LazyWrapper component={EditDesign} />}
                />
                <Route
                  path="/products/designe/edit/:designID"
                  element={<LazyWrapper component={EditDesign} />}
                />
                <Route
                  path="/myProfile/:userId"
                  element={<LazyWrapper component={UserProfilePage} />}
                />
                <Route path="/login" element={<Navigate to="/" />} />
                <Route path="*" element={<ErrorPage />} />
              </>
            ) : (
              <>
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/customer/login" element={<CustomerLogin />} />
                <Route path="*" element={<LoginPage />} />
              </>
            )}
          </Routes>
        </Suspense>
      // {/* </RackProvider> */}
    );
  };

  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <AppContent />
    </BrowserRouter>
  );
}

export default App;